import script from "./PublisherList.vue?vue&type=script&lang=js"
export * from "./PublisherList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0434fdc5"]])

export default __exports__